import { NotReadyQuoteDetails } from 'routes/essential-workspace/components/quote-panel/quote/details/not-ready';
import { QuotePricedDetails } from 'routes/essential-workspace/components/quote-panel/quote/details/priced';
import { QuotePricingDetails } from 'routes/essential-workspace/components/quote-panel/quote/details/pricing';
import { ReadyQuoteDetails } from 'routes/essential-workspace/components/quote-panel/quote/details/ready';
import { QuoteRejectedDetails } from 'routes/essential-workspace/components/quote-panel/quote/details/rejected';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';

import './style.scss';

export function QuoteDetails() {
  const { status } = useQuote();

  switch (status) {
    case 'not-ready':
      return <NotReadyQuoteDetails />;
    case 'ready':
      return <ReadyQuoteDetails />;
    case 'price-in-progress':
      return <QuotePricingDetails />;
    case 'priced':
    case 'price-expired':
      return <QuotePricedDetails />;
    case 'price-rejected':
      return <QuoteRejectedDetails />;
    default:
      return null;
  }
}
